var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 7,
    viewBox: "0 0 10 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.91016 6.40234C5.15625 6.64844 5.56641 6.64844 5.8125 6.40234L9.53125 2.68359C9.80469 2.41016 9.80469 2 9.53125 1.75391L8.92969 1.125C8.65625 0.878906 8.24609 0.878906 8 1.125L5.34766 3.77734L2.72266 1.125C2.47656 0.878906 2.06641 0.878906 1.79297 1.125L1.19141 1.75391C0.917969 2 0.917969 2.41016 1.19141 2.68359L4.91016 6.40234Z",
    fill: "#FF1493"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcArrow);
export default __webpack_public_path__ + "static/media/icArrow.57ce9cb0.svg";
export { ForwardRef as ReactComponent };